<template>
  <div class="container flex" style="padding-bottom: 20px;margin-top: 15px;">
    <div>
      <left></left>
    </div>
    <div class="newslist flex1" style="margin-left: 20px;background-color: #fff;">
   <!-- 	<div class="title flex">
    		<span class="flex1" style="cursor: pointer;">学习指导</span>
    		<span class="tag" style="cursor: pointer;" :class="{'active':id==-1}" @click="tabId(-1)">推荐</span>
    		<span class="tag" style="cursor: pointer;" v-for="item in clist"  :class="{'active':id==item.classifysId}"  @click="tabId(item.classifysId)">{{item.classifysName}}</span>

    	</div> -->
    	<div class="listwrap">
    		<template v-for="item in list">
    		  <div class="flex list" v-if="item.picArray.length==1" @click="handleDetails(item.newsId)">
    		  	<div class="left flex1">
    		  		<div class="titles">
    		  			{{item.newsTitle}}
    		  		</div>
    		  		<div class="flex algin-center margin-t-15">
    		  			<img src="../assets/img/time.png" width="18" height="18" >
    		  			<span class="font14 time" style="margin-right: 15px;">{{item.newsUpdateTime.slice(0,10)}}</span>
    		  			<img src="../assets/img/viewcount.png" width="22" height="13"  >
    		  			<span class="font14 viewcount">{{item.newsViews}}人浏览</span>
    		  		</div>
    		  	</div>
    		  	<div class="right">
    		  		<img :src="item.picArray[0]" class="newscover" >
    		  	</div>
    		  </div>
    		  <div class="flex list" v-if="item.picArray.length==0" @click="handleDetails(item.newsId)">
    		  	<div class="left flex1">
    		  		<div class="titles">
    		  			{{item.newsTitle}}
    		  		</div>
    		  		<div class="flex algin-center margin-t-15">
    		  			<img src="../assets/img/time.png" width="18" height="18" >
    		  			<span class="font14 time" style="margin-right: 15px;">{{item.newsUpdateTime.slice(0,10)}}</span>
    		  			<img src="../assets/img/viewcount.png" width="22" height="13"  >
    		  			<span class="font14 viewcount">{{item.newsViews}}人浏览</span>
    		  		</div>
    		  	</div>

    		  </div>
    		  <div class="flex list" v-if="item.picArray.length==3" @click="handleDetails(item.newsId)">
    		  	<div class="left flex1">
    		  		<div class="titles">
    		  			{{item.newsTitle}}
    		  		</div>
    		  		<div class="flex algin-center margin-t-15">
    		  			<img src="../assets/img/time.png" width="18" height="18" >
    		  			<span class="font14 time" style="margin-right: 15px;">{{item.newsUpdateTime.slice(0,10)}}</span>
    		  			<img src="../assets/img/viewcount.png" width="22" height="13"  >
    		  			<span class="font14 viewcount">{{item.newsViews}}人浏览</span>
    		  		</div>
    		  		<div class="listimg margin-t-15">
    		  			<img :src="voo" class="newscover" v-for="voo in item.picArray" >
    		  		</div>
    		  	</div>

    		  </div>
    		</template>
    	</div>
    	<div class="page" v-if="pages>1">
    		<span class="prev">上一页</span>
    		<span class="pagenum">1</span>
    		<span class="pagenum">2</span>
    		<span class="pagenum">3</span>
    		<span class="pagenum">4</span>
    		<span class="pagenum">5</span>
    		<span class="pagenum">6</span>
    		<span class="prev">下一页</span>
    	</div>
    </div>
  </div>
</template>

<script>
  import left from './left.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          data:'',
          clist:[],
          pageNo:1,
          pageSize:10,
          id:-1,
          list:[],
          pages:0

      }
    },
    methods:{

      getCategory(){
        this.$axios.get(this.$common.news_classify).then((res)=>{
              if(res.data.code==1){
                  this.clist=res.data.data;
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      getList(){
        let data=new FormData();
            data.append('pageNo',this.pageNo);
            data.append('pageSize',this.pageSize);
            // data.append('classify',this.id);
        this.$axios.post(this.$common.news_list,data).then((res)=>{
              if(res.data.code==1){
                  this.list=res.data.data.list;
                  this.pages=res.data.data.pages
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleDetails(id){
        this.$router.push({path:'newsdetail?newsId='+id})
      },
      tabId(id){
        this.id=id;
        this.pageNo=1;
        this.getList()
      }
    },
    created(){
      this.getCategory();
      this.getList()
    }
  }
</script>

<style scoped>
  .newslist {
  	border: 1px solid silver;
  }
  .newslist .title {
  	padding:10px 15px;
  	background-color: #eeeeee;
  	align-items: center;
  }
  .newslist .title .tag {
  	width: 100px;
  	height: 40px;
  	text-align: center;
  	background-color: #fff;
  	line-height: 40px;
  	margin-left: 15px;
  	border: 1px solid silver;
  	font-size: 14px;
  }
  .newslist .title .tag.active {
  	color: #fff;
  	background-color: #4fa7ff;
  }
  .newscover {
  	width: 160px;
  	height: 110px;
  	object-fit: cover;
  }
  .list {
  	padding: 15px;
  	border-bottom: 1px solid silver;
  }
  .viewcount,.time {
  	margin-left: 10px;
  }
  .page{
  	text-align: center;
  	margin-top: 15px;
  }
  .prev {
  	width: 80px;
  	height: 26px;
  	line-height: 26px;
  	color: #fff;
  	background-color: #4fa7ff;
  	display: inline-block;
  	border-radius: 2px;
  	font-size: 14px;
  	border: 1px solid #4fa7ff;
  }
  .pagenum {
  	width: 26px;
  	height: 26px;
  	line-height: 26px;
  	border: 1px solid #ccc;
  	display: inline-block;
  	border-radius: 2px;
  	color: #ccc;
  }
  .titles {
    cursor: pointer;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/newslist.vue